import { Box, Typography, useTheme, alpha } from "@mui/material";

const val = (v) => (v == null || v === "" ? "—" : String(v));

/**
 * One open position, for widths where the 7-column table has to scroll sideways.
 * Values arrive pre-formatted from the feed, so they are rendered as-is.
 */
export const BoughtPositionCard = ({ row }) => {
  const theme = useTheme();
  const primary = theme.palette.primary.main;
  const profitC = theme.palette.profitColor ?? "#18b009";
  const lossC = theme.palette.lossColor ?? "#fa2104";

  const pl = row.profitLoss != null && row.profitLoss !== "" ? Number(row.profitLoss) : null;
  const plColor =
    pl == null || Number.isNaN(pl)
      ? theme.palette.text.secondary
      : pl > 0
        ? profitC
        : pl < 0
          ? lossC
          : theme.palette.neutralColor ?? "#d5c505";

  return (
    <Box
      sx={{
        borderRadius: 2,
        p: 1,
        border: `1px solid ${alpha(primary, 0.14)}`,
        borderLeft: `3px solid ${alpha(plColor, 0.85)}`,
        bgcolor: theme.palette.background.paper,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
        <Typography noWrap title={row.symbol} sx={{ fontWeight: 800, fontSize: "0.82rem", flex: 1, minWidth: 0 }}>
          {row.symbol}
        </Typography>
        <Typography sx={{ fontWeight: 800, fontSize: "0.82rem", color: plColor, whiteSpace: "nowrap" }}>
          {val(row.profitLoss)}
        </Typography>
      </Box>
      <Typography sx={{ fontSize: "0.7rem", color: "text.secondary", mt: 0.15 }}>
        {val(row.qty)} × {val(row.buyPrice)}
      </Typography>
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
          gap: 0.75,
          mt: 0.75,
          pt: 0.75,
          borderTop: `1px dashed ${alpha(theme.palette.divider, 0.8)}`,
        }}
      >
        {[
          { k: "Invested", v: val(row.invested) },
          { k: "Last", v: val(row.currentPrice) },
          { k: "Value", v: val(row.currentValue) },
        ].map(({ k, v }) => (
          <Box key={k} sx={{ minWidth: 0 }}>
            <Typography sx={{ fontSize: "0.6rem", color: "text.secondary", fontWeight: 800, letterSpacing: "0.05em", textTransform: "uppercase" }}>
              {k}
            </Typography>
            <Typography noWrap title={v} sx={{ fontSize: "0.78rem", fontWeight: 700 }}>
              {v}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default BoughtPositionCard;
